import PropTypes from 'prop-types';
import React from 'react';
import useLicenceRedirect from './useTokenRedirect';

/**
 * HOC (Higher Order Component) que proporciona la funcionalidad de redirección de licencias
 * a cualquier componente de classes que lo necesite.
 *
 * @template T
 * @param {React.ComponentType<T>} WrappedComponent - Componente a envolver
 * @returns {React.FC<T & { getRedirectUrl: () => string }>} Componente mejorado con la prop getRedirectUrl
 */
const withLicenseShopURL = WrappedComponent => {
  const WithLicenseShopURL = props => {
    const { getRedirectUrl } = useLicenceRedirect();

    return <WrappedComponent {...props} getRedirectUrl={getRedirectUrl} />;
  };

  // Mejor manejo del displayName para debugging
  const wrappedComponentName =
    WrappedComponent.displayName || WrappedComponent.name || 'Component';
  WithLicenseShopURL.displayName = `WithLicenseShopURL(${wrappedComponentName})`;

  // Agregamos PropTypes para mejor documentación y validación
  WithLicenseShopURL.propTypes = {
    ...WrappedComponent.propTypes,
    getRedirectUrl: PropTypes.func.isRequired,
  };

  return WithLicenseShopURL;
};

export default withLicenseShopURL;
